<script setup lang="ts">
import UIKit from '@pocketprep/ui-kit'

const {
    ModalContainer,
    Modal,
} = UIKit

const emit = defineEmits<{
    close: []
}>()

const closeModal = () => {
    emit('close')
}
</script>

<template>
    <Portal to="modal">
        <ModalContainer key="ssoTransitionModal" @close="closeModal">
            <template #modal>
                <Modal
                    v-dark
                    class="sso-transition"
                    :show-close-button="true"
                    @close="closeModal"
                >
                    <img
                        class="sso-transition__gif"
                        src="@/assets/images/sso-transition.gif"
                    >
                    <div class="sso-transition__title">
                        Welcome to Instructor Dashboard
                    </div>
                    <div class="sso-transition__subtitle">
                        Help your students prepare for and pass their exams.
                    </div>
                </Modal>
            </template>
        </ModalContainer>
    </Portal>
</template>

<style lang="scss">
.sso-transition {
    max-width: 374px;
    padding: 16px 32px 40px;
    text-align: center;
    box-sizing: border-box;
    left: 50%;
    position: absolute;
    transform: translateX(-50%);
    top: 120px;

    &__gif {
        width: 248px;
        margin: 0 31px 14px;
    }

    &__title {
        font-size: 18px;
        line-height: 25px;
        letter-spacing: 0.3px;
        font-weight: 600;
        margin-bottom: 8px;
    }

    &__subtitle {
        max-width: 278px;
        margin: 0 auto;
        font-size: 15px;
        line-height: 20px;
        font-weight: 500;
    }
}
</style>
